function initSlider(currentPage) {
	let $speakers = currentPage.find('.speakers');
	let $items = $speakers.find('.speakers__items');

	$items.slick({
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1230,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 1025,
				settings: {
					adaptiveHeight: true,
					slidesToShow: 1,
				},
			},
		],
	});
}

export default {
	initSlider,
};
